import React, { useState } from 'react';
import { Divider, Icon } from '@goodfynd/ui';

import {
  StyledAnchor,
  StyledMenu,
  StyledMenuItem,
  StyledMenuLabel,
} from './styles';
import type { MenuOption, MenuProps } from './types';

export default function Menu({
  anchor,
  anchorCSS,
  onChange,
  options = [],
  selected,
  ...props
}: MenuProps) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClose = () => setAnchorEl(null);
  const handleMenuClick = (e: ClickButtonEvent) => {
    setAnchorEl(e.currentTarget);
  };

  const handleOptionSelect = (option: MenuOption) => {
    option.onClick?.(option);
    onChange?.(option);
    handleClose();
  };

  if (options.length === 0) {
    return null;
  }

  const selectedValue = Array.isArray(selected) ? undefined : selected;
  return (
    <>
      <StyledAnchor css={anchorCSS} onClick={handleMenuClick}>
        {anchor}
      </StyledAnchor>

      <StyledMenu
        anchorEl={anchorEl}
        elevation={0}
        id="search-filter-menu"
        onClose={handleClose}
        open={open}
        anchorOrigin={{
          horizontal: 'right',
          vertical: 'bottom',
        }}
        transformOrigin={{
          horizontal: 'right',
          vertical: 'top',
        }}
        {...props}
      >
        {options
          .filter((option) => !option.hide)
          .map((option) =>
            option.divider ? (
              <Divider key={option.key} />
            ) : (
              <StyledMenuItem
                disableRipple
                key={option.value || option.key || option.label?.toString()}
                onClick={() => handleOptionSelect(option)}
              >
                <StyledMenuLabel>
                  {typeof option.icon === 'string' ? (
                    <Icon name={option.icon} />
                  ) : (
                    option.icon
                  )}
                  {option.label}
                </StyledMenuLabel>

                {selectedValue && option.value === selectedValue && (
                  <Icon name="check" />
                )}
              </StyledMenuItem>
            )
          )}
      </StyledMenu>
    </>
  );
}
